import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { NgCommonModule } from '@principle-theorem/ng-shared';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import { InformationBoxComponent } from '@principle-theorem/ng-principle-shared';
import { IReferral } from '@principle-theorem/principle-core/interfaces';
import { WithRef } from '@principle-theorem/shared';
import { ReferralPortalComponent } from '../../pages/referral-portal/referral-portal.component';

export interface IReferralPreviewDialogData {
  referral: WithRef<IReferral>;
}

@Component({
  selector: 'pr-referral-preview-dialog',
  imports: [
    NgCommonModule,
    MatDialogModule,
    MatButtonModule,
    MatToolbarModule,
    MatIconModule,
    InformationBoxComponent,
    ReferralPortalComponent,
  ],
  templateUrl: './referral-preview-dialog.component.html',
  styleUrl: './referral-preview-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReferralPreviewDialogComponent {
  public readonly data = inject<IReferralPreviewDialogData>(MAT_DIALOG_DATA);
}
